<script lang="ts">
	import type { PageData } from './$types';
	import MeetingHeader from '$lib/components/meetings/MeetingHeader.svelte';
	import MeetingsList from '$lib/components/meetings/MeetingsList.svelte';
	import YearlyNavigation from '$lib/components/meetings/YearlyNavigation.svelte';

	export let data: PageData;
</script>

<svelte:head>
	<title>Meeting Minutes | Desert Shores Amateur Radio Club</title>
	<meta
		name="description"
		content="Meeting minutes and records for the Desert Shores Amateur Radio Club meetings, including board meetings and general membership meetings."
	/>
</svelte:head>

<div class="mx-auto max-w-6xl">
	<MeetingHeader
		title="Meeting Minutes"
		description="Access meeting minutes and records from our club meetings, including general membership meetings and board meetings."
	/>

	<div class="grid gap-8 md:grid-cols-2">
		<!-- Recent Minutes -->
		<div class="rounded-lg bg-white p-6 shadow-sm dark:bg-gray-800">
			<MeetingsList
				meetings={data.recentMinutes || []}
				title="Recent Minutes"
				emptyMessage="Meeting minutes will be posted here after each meeting."
			/>
		</div>

		<!-- Meeting Schedule -->
		<div class="rounded-lg bg-white p-6 shadow-sm dark:bg-gray-800">
			<h2 class="mb-4 text-xl font-semibold text-gray-900 dark:text-white">Meeting Schedule</h2>
			<div class="space-y-4">
				<div class="rounded-lg bg-blue-50 p-4 dark:bg-blue-900/20">
					<h3 class="font-medium text-blue-900 dark:text-blue-100">General Membership</h3>
					<p class="text-sm text-blue-800 dark:text-blue-200">
						First and Third Tuesday of every month at 6:30 PM Pacific
					</p>
					<p class="mt-1 text-xs text-blue-700 dark:text-blue-300">(with holiday exceptions)</p>
				</div>
				<div class="rounded-lg bg-green-50 p-4 dark:bg-green-900/20">
					<h3 class="font-medium text-green-900 dark:text-green-100">Board Meetings</h3>
					<p class="text-sm text-green-800 dark:text-green-200">As needed, typically quarterly</p>
				</div>
			</div>
		</div>
	</div>

	<!-- Browse by Year -->
	<div class="mt-8">
		<YearlyNavigation yearlyMinutes={data.yearlyMinutes || {}} />
	</div>

	<!-- Information Section -->
	<div class="mt-8 rounded-lg bg-gray-50 p-6 dark:bg-gray-900">
		<h2 class="mb-4 text-xl font-semibold text-gray-900 dark:text-white">About Meeting Minutes</h2>
		<div class="prose max-w-none text-gray-700 dark:text-gray-300">
			<p>
				Meeting minutes are official records of our club's meetings, documenting discussions,
				decisions, and actions taken. They serve as an important reference for club members and help
				maintain transparency in club operations.
			</p>
			<h3 class="mt-4 text-lg font-semibold text-gray-900 dark:text-white">What's Included:</h3>
			<ul class="mt-2 space-y-1">
				<li>• Attendance records</li>
				<li>• Officer and committee reports</li>
				<li>• New and old business discussions</li>
				<li>• Motions, votes, and decisions</li>
				<li>• Upcoming events and announcements</li>
			</ul>
		</div>
	</div>
</div>
